import FormControl from "@material-ui/core/FormControl";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import React from "react";
import * as PropTypes from "prop-types";
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles({
    root: {
        textOverflow: "ellipsis",
        lineHeight: "1.57em",
        maxHeight: "1.57em",
        overflow: "hidden"
    }
})


const DefaultInput = ({label, ...rest}) => {
    const classes = useStyles()
    return (
        <FormControl fullWidth>
            <InputLabel className={classes.root}>{label}</InputLabel>
            <Input
                {...rest}
            />
        </FormControl>
    )
}


DefaultInput.propTypes = {
    label: PropTypes.string
}

export default DefaultInput;
